export default "__VITE_PUBLIC_ASSET__a6e17abe__"